import styled from "styled-components";
import Logo from "./Logo";

export default styled(Logo)`
  .header__logo {
    width: 100%;
  }
`;
